import { isProspectiveInventoryStatus } from 'modules/equipment';
import { InventoryEquipmentItem } from '../api/types';

/**
 * DR-10802: the identifiers a Prospective unit is still missing. Lenders and documents may need them, so the rep
 * sees a flag until the unit is converted. Empty for any other unit.
 */
export const getProspectiveUnitMissingFields = (item: InventoryEquipmentItem): string[] => {
  if (!isProspectiveInventoryStatus(item.inventoryStatus)) return [];

  const { vin, mileage, hours } = item.equipment.details;

  return [!vin && 'VIN/serial', !mileage && !hours && 'hours/miles'].filter((field): field is string => !!field);
};
